import { render, staticRenderFns } from "./OrderProducts.vue?vue&type=template&id=1098b95c&scoped=true"
import script from "./OrderProducts.vue?vue&type=script&lang=js"
export * from "./OrderProducts.vue?vue&type=script&lang=js"
import style0 from "./OrderProducts.vue?vue&type=style&index=0&id=1098b95c&prod&lang=scss&scoped=true"
import style1 from "./OrderProducts.vue?vue&type=style&index=1&id=1098b95c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1098b95c",
  null
  
)

export default component.exports